import sectionBannerBasicB1Css from '../css-snippets/section-banner-basic-b1';

const html = `
<style>${sectionBannerBasicB1Css}</style>
<div class="wrapper-container" id="" data-id="" data-attribute="wrapper-container" data-background-color="#ffffff"
  data-enable-background-image="false" data-background="#ffffff" data-top-padding="true" data-bottom-padding="true"
  data-opacity="0" data-text-color="#ffffff"
  style="--text-color: #ffffff; color: rgb(255, 255, 255); background-color: rgb(255, 255, 255);">
  <div class="background-section"
    data-background-img="https://cdn.skyfastimg.com/images/2025/12/24/image-694b6fb1c482a7f2cb421952.jpeg?w=1200&amp;h=50&amp;q=80"
    data-attribute="background-section" data-opacity="1"
    style="opacity: 1; background-image: url('https://cdn.skyfastimg.com/images/2025/12/24/image-694b6fb1c482a7f2cb421952.jpeg?w=1200&amp;h=50&amp;q=80');">
  </div>
  <div class="background-section-mobile"
    data-background-img="https://cdn.skyfastimg.com/images/2025/12/24/image-694b7022cedce61555185a46.webp?w=1200&amp;h=50&amp;q=80"
    data-attribute="background-section-mobile"
    style="opacity: 1; background-image: url('https://cdn.skyfastimg.com/images/2025/12/24/image-694b7022cedce61555185a46.webp?w=1200&amp;h=50&amp;q=80');"
    data-opacity="1">
  </div>
  <div data-attribute="overlay-bg" class="overlay-bg" data-color="#e8b64a" data-opacity="0"
    style="opacity: 0; background-color: rgb(232, 182, 74);"></div>

  <div class="container">
    <div class="wrap-content" data-background-color="#281707" data-attribute="wrap-content" data-align="left"
      style="background-color: rgb(40, 23, 7); text-align: left;">
      <div data-attribute="content-title" class="content-title">
        <h3 style="text-align:center;">Crafted for Longevity, Designed to Impress</h3>
      </div>
      <div class="list-item">
        <div data-attribute="item" class="item">
          <div data-attribute="icon" class="icon">
            <img
              src="https://cdn.skyfastimg.com/images/2025/12/24/image-694b6fd174a8f57acf654f58.png?w=50&amp;h=50&amp;q=80"
              alt="">
          </div>
          <div data-attribute="item-text" class="item-text">Made from high-grade ABS and stainless components</div>
        </div>

        <div data-attribute="item" class="item">
          <div data-attribute="icon" class="icon">
            <img
              src="https://cdn.skyfastimg.com/images/2025/12/24/image-694b6df01df69eb20ed44d2e.png?w=50&amp;h=50&amp;q=80"
              alt="">
          </div>
          <div data-attribute="item-text" class="item-text">Sealed design for rain, wind, and snow</div>
        </div>

        <div data-attribute="item" class="item">
          <div data-attribute="icon" class="icon">
            <img
              src="https://cdn.skyfastimg.com/images/2025/12/24/image-694b6dfa91991d5e42d7fa15.png?w=50&amp;h=50&amp;q=80"
              alt="">
          </div>
          <div data-attribute="item-text" class="item-text">Flickering flame tech mimics real firelight</div>
        </div>

        <div data-attribute="item" class="item">
          <div data-attribute="icon" class="icon">
            <img
              src="https://cdn.skyfastimg.com/images/2025/12/24/image-694b6e03da1cef7759bdfd47.png?w=50&amp;h=50&amp;q=80"
              alt="">
          </div>
          <div data-attribute="item-text" class="item-text">High-efficiency solar panel with dusk-to-dawn battery</div>
        </div>

        <div data-attribute="item" class="item">
          <div data-attribute="icon" class="icon">
            <img
              src="https://cdn.skyfastimg.com/images/2025/12/24/image-694b6e0e84607dc6557f696b.png?w=50&amp;h=50&amp;q=80"
              alt="">
          </div>
          <div data-attribute="item-text" class="item-text">Heavy-duty stakes and hooks for secure placement anywhere
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
